import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "unfold"
const UnfoldIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M17.03 15.905 12 20.935 6.97 15.906 8.03 14.845 12 18.815 15.97 14.844zM17.03 8.095 15.97 9.155 12 5.185 8.03 9.156 6.97 8.095 12 3.065z" />
        </svg>
      }
    </span>
  )
}
export default UnfoldIcon
